module.exports = __webpack_public_path__ + "static/media/  (133).4272317c.jpg";